import React from 'react';
import { Helmet } from "react-helmet";
import { Link, graphql } from 'gatsby';
import parse from 'html-react-parser';

import { Layout } from '../layouts/Main';

import {
    Header,
    Footer,
    BlockPostSellbox,
    BreadCrumbBlock,
    HelpfulArticleForm,
    Tabs,
} from '../components';

import { convertDate } from '../utils/convertDate';
import { checkName } from '../utils/checkName';

const BlogpostTemplate = (props) => {
    const blogpost = props.pageContext.node;
    const date = convertDate(blogpost.publish_date);
    const posts = props.data.mb.posts.filter(item => item.id !== blogpost.id);
    const linkedPosts = posts.length >= 2 ? posts.splice(0, 2) : [];
    const pathname = props.path;
    let firstLink, secondLink = "/";
    if (linkedPosts.length) {
        firstLink = linkedPosts[0].slug;
        secondLink = linkedPosts[1].slug;
    }

    const name = checkName(
        blogpost.author && blogpost.author.username ||
        blogpost.created_by && blogpost.created_by.firstname
    );

    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
                <meta content="article" property="og:type" />
                <meta content={`https://www.freeconferencecall.com/support-center${pathname}`} property="og:url" />
                <meta content={blogpost.preview && blogpost.preview.url ? `https://www.freeconferencecall.com/support-center/api${blogpost.preview.url}` : "https://www.freeconferencecall.com/images/fcc_logo_fb.png"} property="og:image" />
                <meta content={blogpost.title} property="og:title" />
                <meta content="FreeConferenceCall.com" property="og:site_name" />
                <meta content="freeconferencecall" property="fb:admins" />
                {
                    blogpost.metadata.map(item => (
                        <meta key={item.id} name={item.name} content={item.content} />
                    ))
                }

                {(blogpost.status === 'draft') ? <meta content="noindex, nofollow" name="robots" /> : false}

                <title>{blogpost.title} | FreeConferenceCall.com</title>

            </Helmet>
            <Header />

            <BlockPostSellbox title={blogpost.title} description={blogpost.sub_title} icon={blogpost.title_icon?.url} title_centered={blogpost.title_centered} />

            <BreadCrumbBlock location={props.location}  label={blogpost.title} categories={blogpost.categories} subcategories={blogpost.subcategories} />
            
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        {parse(blogpost.content)}

                        {
                            blogpost?.tab.length > 0 && <Tabs tabs={blogpost.tab} />
                        }
                    </div>
                </div>
            </div>

            <HelpfulArticleForm blogpost_id={blogpost.id} />
            <Footer />
        </Layout>
    );
};

export default BlogpostTemplate;

export const pageQuery = graphql`
query BlogpostTemplateQuery($category: String, $date: String) {
    mb {
        posts: blogposts(where: {
            categories: {
                Name: $category
            },
            publish_date_lte: $date,
            status: "published"
        },
        sort: "publish_date:desc",
        limit: 6) {
            id
            title
            categories {
                id
                link
                Name
                tag
            }
            preview {
                url
            }
            author{
                username
            }
            created_by {
                firstname
            }
            created_at
            publish_date
            slug
            banner
        }
        recent:blogposts(where: {publish_date_lte: $date, status: "published"}, sort: "publish_date:desc", limit: 4){
            id
            title
            created_at
            publish_date
            categories {
                id
                Name
                link
                tag
            }
            preview{
                url
            }
            author{
                username
            }
            created_by {
                firstname
            }
            slug
            banner
        }
    }
}
`;
